module.exports = __webpack_public_path__ + "static/sageplaysuit-8de204d55404374a12719e1b79eb16a9.jpeg";